// Core
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

// Custom Components
import QuestionPage from '../../../../../pages/QuestionPage';
import Question from '../../../../../components/primitive/Question';
import QuestionElement from '../../../../../components/complex/QuestionElement';
import ExpandableQuestionDetails from '../../../../../components/complex/ExpandableQuestionDetails';

const Q7 = ({ selection, inner, texts, setSelection, setInner }) => {
    const [ textfield, setTextfield ] = useState('');

    let history = useHistory();

    const onClickNavigate = direction => () => {
        history.push(direction === 'back' ? '/withShop/q6' : '/withShop/summary');
    };

    const onChange = e => {
        setSelection('q7', e.target.value);
    };

    const onChangeInner = key => e => {
        if (textfield && textfield.length > 0) {
            setTextfield(' ');
        };

        setInner('q7', key, e.target.value)
    };

    const onChangeInnerText = e => {
        setInner('q7', 'selection', e.target.value)
        setTextfield(e.target.value);
    };

    return (
        <QuestionPage onClickLeft={onClickNavigate('back')} onClickRight={onClickNavigate()}>
            <Question
                title={texts.title}
                questionNumber={7}
                questionTotal={7}
            >
                {
                    texts.content.map((field, i) =>
                        <div key={i}>
                            <QuestionElement
                                questionField={field}
                                stateValue={selection}
                                onChange={onChange}
                            />
                            {
                                field.content && field.content.length > 0
                                    ? (
                                        <ExpandableQuestionDetails
                                            fields={field.content}
                                            onChangeInner={onChangeInner('selection')}
                                            onChangeInnerText={onChangeInnerText}
                                            stateValueInner={inner.selection}
                                            stateValueInnerText={textfield}
                                            isOpen={selection === field.value}
                                        />
                                    ) : (
                                        null
                                    )
                            }
                        </div>
                    )
                }
            </Question>
        </QuestionPage>
    );
};

export default Q7;